// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_actionButtons__YERXC {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
}
@media screen and (min-width: 768px) {
  .styles_actionButtons__YERXC {
    flex-direction: row;
    gap: 12px;
  }
}
.styles_actionButtons__YERXC button {
  padding: 8px 16px;
  border-radius: 12px;
  border: none;
  transition: opacity 0.2s ease-in-out;
  font-weight: 600;
  width: 100%;
}
@media screen and (min-width: 768px) {
  .styles_actionButtons__YERXC button {
    width: unset;
  }
}
.styles_actionButtons__YERXC button:hover {
  cursor: pointer;
  opacity: 0.8;
}
.styles_actionButtons__YERXC button.styles_reset__X-qye {
  background-color: #bb5240;
  color: #fff;
}
.styles_actionButtons__YERXC button.styles_save__Abc2d {
  background-color: #6ba7a8;
  color: #fff;
}
.styles_actionButtons__YERXC button.styles_complete__rIROH {
  background-color: rgb(46, 114, 46);
  color: #fff;
}
.styles_actionButtons__YERXC button.styles_complete__rIROH:disabled {
  opacity: 0.6;
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/SingleTranscript/ActionButtons/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AACF;AACE;EANF;IAOI,mBAAA;IACA,SAAA;EAEF;AACF;AAAE;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,oCAAA;EACA,gBAAA;EACA,WAAA;AAEJ;AAAI;EARF;IASI,YAAA;EAGJ;AACF;AADI;EACE,eAAA;EACA,YAAA;AAGN;AAAI;EACE,yBAAA;EACA,WAAA;AAEN;AACI;EACE,yBAAA;EACA,WAAA;AACN;AAEI;EACE,kCAAA;EACA,WAAA;AAAN;AAEM;EACE,YAAA;AAAR","sourcesContent":[".actionButtons {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-items: center;\n\n  @media screen and (min-width: 768px) {\n    flex-direction: row;\n    gap: 12px;\n  }\n\n  button {\n    padding: 8px 16px;\n    border-radius: 12px;\n    border: none;\n    transition: opacity 0.2s ease-in-out;\n    font-weight: 600;\n    width: 100%;\n\n    @media screen and (min-width: 768px) {\n      width: unset;\n    }\n\n    &:hover {\n      cursor: pointer;\n      opacity: 0.8;\n    }\n\n    &.reset {\n      background-color: #bb5240;\n      color: #fff;\n    }\n\n    &.save {\n      background-color: #6ba7a8;\n      color: #fff;\n    }\n\n    &.complete {\n      background-color: rgb(46, 114, 46);\n      color: #fff;\n\n      &:disabled {\n        opacity: 0.6;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionButtons": `styles_actionButtons__YERXC`,
	"reset": `styles_reset__X-qye`,
	"save": `styles_save__Abc2d`,
	"complete": `styles_complete__rIROH`
};
export default ___CSS_LOADER_EXPORT___;
